<div class="income-chart-container">

  <!-- Loading / Empty State -->
  <div *ngIf="docsCount === 0" class="empty-state text-center py-12">
    <div class="h-16 w-16 mx-auto mb-4 rounded-2xl bg-blue-50 dark:bg-blue-900/20 flex items-center justify-center">
      <mat-icon [svgIcon]="'tabler_outline:chart-area-line'" class="h-8 w-8 text-blue-400"></mat-icon>
    </div>
    <h3 class="text-base font-medium text-gray-700 dark:text-gray-300 mb-1">Brak danych do wyświetlenia</h3>
    <p class="text-sm text-gray-500 dark:text-gray-400">Wystaw pierwszą fakturę, aby zobaczyć statystyki</p>
  </div>

  <ng-container *ngIf="docsCount > 0">

    <!-- Compact Filter Row -->
    <div class="flex flex-wrap items-center justify-between gap-3 mb-5">
      
      <!-- Period Buttons -->
      <div class="flex items-center gap-2">
        <div class="inline-flex items-center bg-gray-100 dark:bg-slate-800 rounded-lg p-1">
          <button 
            *ngFor="let range of [
              { key: 'THIS_MONTH', label: 'Ten miesiąc' },
              { key: 'LAST_30_DAYS', label: 'Ostatnie 30 dni' },
              { key: 'THIS_YEAR', label: 'Rok' },
              { key: 'LAST_12_MONTHS', label: '12 mies.' }
            ]"
            (click)="range.key === 'THIS_MONTH' ? setThisMonthRange() : range.key === 'LAST_30_DAYS' ? setLast30DaysRange() : range.key === 'THIS_YEAR' ? setThisYearRange() : setLastMonthsRange(12)"
            class="px-3 py-1.5 text-xs font-medium rounded-md transition-all duration-200"
            [ngClass]="{
              'bg-white dark:bg-slate-700 text-blue-600 dark:text-blue-400 shadow-sm': selectedRange === range.key,
              'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300': selectedRange !== range.key
            }">
            {{range.label}}
          </button>
        </div>

        <!-- Date Range Selector -->
        <div class="inline-flex items-center bg-gray-100 dark:bg-slate-800 rounded-lg p-1">
          <div class="relative">
            <button 
              (click)="startPicker.open()"
              class="px-3 py-1.5 text-xs font-medium rounded-md transition-all duration-200"
              [ngClass]="{
                'bg-white dark:bg-slate-700 text-blue-600 dark:text-blue-400 shadow-sm': !selectedRange,
                'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300': selectedRange
              }">
              {{startDate.toFormat('dd.MM.yyyy')}}
            </button>
            <input 
              matInput 
              [matDatepicker]="startPicker"
              [value]="startDate"
              (dateChange)="rangeChanged('start', $event)"
              class="date-input-hidden">
            <mat-datepicker #startPicker></mat-datepicker>
          </div>
          
          <span class="text-gray-400 text-xs px-1">—</span>
          
          <div class="relative">
            <button 
              (click)="endPicker.open()"
              class="px-3 py-1.5 text-xs font-medium rounded-md transition-all duration-200"
              [ngClass]="{
                'bg-white dark:bg-slate-700 text-blue-600 dark:text-blue-400 shadow-sm': !selectedRange,
                'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300': selectedRange
              }">
              {{endDate.toFormat('dd.MM.yyyy')}}
            </button>
            <input 
              matInput 
              [matDatepicker]="endPicker"
              [value]="endDate"
              (dateChange)="rangeChanged('end', $event)"
              class="date-input-hidden">
            <mat-datepicker #endPicker></mat-datepicker>
          </div>
        </div>
      </div>

      <!-- View Mode & Field Selector -->
      <div class="flex items-center gap-2">
        <button mat-button class="!min-w-0 !px-3 !py-1 !h-8 !rounded-lg !text-xs !text-gray-600 dark:!text-gray-400" [matMenuTriggerFor]="viewTypesMenu">
          <mat-icon [svgIcon]="viewMode === 'daily' ? 'tabler_outline:calendar-event' : 'tabler_outline:calendar-month'" class="!h-4 !w-4"></mat-icon>
          <mat-icon [svgIcon]="'tabler_outline:chevron-down'" class="!h-3 !w-3 !ml-0.5"></mat-icon>
          Grupowanie
        </button>

        <mat-menu #viewTypesMenu="matMenu">
          <button mat-menu-item (click)="setViewMode('daily')">
            <mat-icon [svgIcon]="viewMode === 'daily' ? 'tabler_outline:check' : 'tabler_outline:calendar-event'"></mat-icon>
            Dziennie
          </button>
          <button mat-menu-item (click)="setViewMode('monthly')">
            <mat-icon [svgIcon]="viewMode === 'monthly' ? 'tabler_outline:check' : 'tabler_outline:calendar-month'"></mat-icon>
            Miesięcznie
          </button>
        </mat-menu>

        <!-- <button mat-button class="!min-w-0 !px-3 !py-1 !h-8 !rounded-lg !text-xs !text-gray-600 dark:!text-gray-400" [matMenuTriggerFor]="fieldMenu">
          {{selectedField.text}}
          <mat-icon [svgIcon]="'tabler_outline:chevron-down'" class="!h-3 !w-3 !ml-1"></mat-icon>
        </button>

        <mat-menu #fieldMenu="matMenu">
          <button mat-menu-item *ngFor="let field of countFieldOptions" (click)="selectField(field)">
            <mat-icon [svgIcon]="field.value === selectedField.value ? 'tabler_outline:check' : 'tabler_outline:coin'"></mat-icon>
            {{field.text}}
          </button>
        </mat-menu> -->
      </div>
    </div>

    <!-- Summary Row -->
    <div class="flex items-center gap-6 mb-5">
      
      <!-- Income -->
      <div class="flex items-center gap-2">
        <div class="h-2.5 w-2.5 rounded-full bg-emerald-500"></div>
        <span class="text-xs text-gray-500 dark:text-gray-400">Przychody</span>
        <div *ngIf="summaries.length > 0" class="flex flex-wrap gap-x-2">
          <div *ngFor="let summary of summaries" class="flex items-baseline gap-0.5">
            <span class="text-sm font-semibold text-gray-900 dark:text-white">{{summary.amountDecimal}}</span>
            <span class="text-xs text-gray-400">{{summary.currency}}</span>
          </div>
        </div>
        <span *ngIf="summaries.length === 0" class="text-sm text-gray-400">0,00 PLN</span>
      </div>

      <!-- Expenses -->
      <div class="flex items-center gap-2">
        <div class="h-2.5 w-2.5 rounded-full bg-rose-500"></div>
        <span class="text-xs text-gray-500 dark:text-gray-400">Koszty</span>
        <div *ngIf="expenseSummaries.length > 0" class="flex flex-wrap gap-x-2">
          <div *ngFor="let summary of expenseSummaries" class="flex items-baseline gap-0.5">
            <span class="text-sm font-semibold text-gray-900 dark:text-white">{{summary.amountDecimal}}</span>
            <span class="text-xs text-gray-400">{{summary.currency}}</span>
          </div>
        </div>
        <span *ngIf="expenseSummaries.length === 0" class="text-sm text-gray-400">0,00 PLN</span>
      </div>
    </div>

    <!-- Chart -->
    <div class="chart-wrapper rounded-xl -mx-2">
      <apx-chart 
        #chartRef
        [chart]="chartOptions.chart" 
        [colors]="chartOptions.colors" 
        [dataLabels]="chartOptions.dataLabels"
        [fill]="chartOptions.fill" 
        [grid]="chartOptions.grid" 
        [series]="chartOptions.series" 
        [stroke]="chartOptions.stroke"
        [tooltip]="chartOptions.tooltip" 
        [xaxis]="chartOptions.xaxis" 
        [yaxis]="chartOptions.yaxis"
        [plotOptions]="chartOptions.plotOptions">
      </apx-chart>
    </div>

    <!-- Period Info -->
    <div class="text-center mt-3">
      <span class="text-xs text-gray-400">Okres: {{visibleDataText}}</span>
    </div>

  </ng-container>

</div>